// extracted by mini-css-extract-plugin
export default {"ns_offers_group_card":"OfferListPage_ns_offers_group_card__tsXT+"};